import _ from 'lodash';
import { ChartType } from '../types/prism';
import { isSafariBrowser } from './common-util';
import { enableHostedChartSameOriginSafari } from '@thoughtspot/session-service';
export function addQueryParamsToUrl(url, params) {
    if (!url)
        return url;
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
        if (!_.isNil(value)) {
            urlObj.searchParams.set(key, value.toString());
        }
    });
    return urlObj.toString();
}
export function shouldLoadChartInSameOrigin(chartType) {
    if (!enableHostedChartSameOriginSafari()) {
        return false;
    }
    if (chartType === ChartType.MuzeStudio) {
        return false;
    }
    if (isSafariBrowser()) {
        return true;
    }
    return false;
}
//# sourceMappingURL=use-chart-frame.util.js.map